<script>
	// Stores 
	import { textSite, mailRH } from '../store.js'; 

	// Componentes
	import { Router, Link, link , Route } from "svelte-routing";
	import PageHeader from "../components/PageHeader.svelte";
	import Forms from "../components/Forms.svelte";

	// Code
	let titlePage = 'Trabalhe Conosco ';    

	let fields = [
		{
			title:  'Nome *',
			name:   'nome',
			required: 'required',
		},
		{
			title:  'Telefone *',
			name:   'telefone',
			required: 'required',
			classe: 'mask-telefone'
		},
		{
			title:  'Email *',
			name:   'email',
			type: 'email',
			required: 'required',
		},
		{
			title:  'Endereço *',
			name:   'endereco',
			required: 'required',
		},
		{
			title:  'Cidade *',
			name:   'cidade',
			required: 'required',
		},
		{
			title:  'CEP',
			name:   'cep',
			classe: 'mask-cep'
		},
		{
			title:  'Área de Interesse',
			name:   'area-interesse',
		},
		{
			title:  'Experiências Profissionais',
			name:   'experiencias-profissionais',
		},
		{
			title:  'Última Empresa',
			name:   'ultima-empresa',
		},
		{
			title:  'Últimas Atividades',
			name:   'ultimas-atividades',
		},
		{
			title:  'Anexos',
			name:   'trabalheconosco-anexos',
			type: 'fileinput',
			maxFileCount: 3,
			minFileCount: 1,
			allowedFileTypes: ['pdf']
		},
	];      
	
	const message = `
Nome: {nome}
Telefone: {telefone}
Email: {email}
Endereço: {endereco}
Cidade: {cidade}
CEP: {cep}
Área de Interesse: {area-interesse}
Experiências Profissionais: {experiencias-profissionais}
Última Empresa: {ultima-empresa}
Últimas Atividades: {ultimas-atividades}

{info}
	`;

	let loading = false;
	function send() {
		loading = true;
	}    

</script>

<PageHeader title={titlePage} buttons="">
	<div class="subtitle" slot="subtitle">
		<div class="container">
			<p>Para se inscrever em nosso banco de talentos, preencha abaixo o formulário com seus dados de contato e envie o arquivo do seu currículo.</p>
			
		</div>
	</div>
</PageHeader>

<div class="container">
	<div class="text-center">
		<p>Nossa equipe entrará em contato, caso identifique alguma oportunidade dentro de sua área de interesse.</p>
	</div>
	<div class="offset-md-3 col-md-6 pl-0 pr-0">    
		<hr class="line-separator">
		<Forms fields={fields} destiny={$mailRH} subjectTitle="{titlePage}" {message} htmlbody={false} />
	</div>
</div>